import * as z from "zod/v4";

export const unverifyUspsContractRates = {
  name: "unverifyUspsContractRates" as const,
  input: z.object({ uspsCarrierAccountIntegrationId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
